var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","disabled":_vm.disableTooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({on:{"mouseover":function($event){return _vm.setVisibility($event)}}},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',{domProps:{"textContent":_vm._s(_vm.tooltipText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }